// extracted by css-extract-rspack-plugin
export default {"page":"page-L0EB2D","mainMap":"mainMap-nFlxcb","mainContent":"mainContent-LuMYHP"};